'use client'
import { ArticleListCarousel } from 'components/ArticleListCarousel'
import Section from 'components/Section'
import { useMemoizedContentGetter } from 'utils/contentful'
import styles from './ArticleListCarouselSection.module.scss'

function ArticleListCarouselSection({ content }) {
  const { title, linkCta, link, backgroundConfig } = useMemoizedContentGetter(content, [
    'title',
    'linkCta',
    'link',
    'backgroundConfig',
  ])
  const relatedArticles = content?.fields?.relatedContentCollection?.items
  const config = content?.fields?.additionalConfiguration?.jsonContent
  return (
    <Section
      className={styles['container']}
      data-variant-background={config?.variantBackground}
      data-testid="article-list-carousel-section"
      fullBackground={backgroundConfig?.jsonContent?.fullBackground ?? false}
    >
      <ArticleListCarousel
        title={title?.textContent}
        relatedArticles={relatedArticles}
        linkCta={linkCta}
        link={link}
        config={config}
        titleComponent="h2"
      />
    </Section>
  )
}

export { ArticleListCarouselSection }
export default ArticleListCarouselSection
